import {
	FeatureStateSymbol,
	PageFeatureConfigSymbol,
	ReducedMotionSymbol,
	BrowserWindowSymbol,
	CompsLifeCycleSym,
} from '@wix/thunderbolt-symbols'
import { withDependencies, named } from '@wix/thunderbolt-ioc'
import type { IMotionEffectsInitCallbackFactory } from './types'
import { MotionEffectsManager } from './MotionEffectsManager'
import { name } from './symbols'
import { isSSR } from '@wix/thunderbolt-commons'

const motionEffectsInitCallbackFactory: IMotionEffectsInitCallbackFactory = (
	featureConfig,
	featureState,
	reducedMotion,
	browserWindow,
	compsLifeCycle
) => (motionEffectsManager?: MotionEffectsManager) => {
	const { animationDefsByCompId, compIdToRotations: rotations } = featureConfig

	if (!motionEffectsManager) {
		return
	}

	const unhideComponents = (compIds: Array<string>) =>
		compIds.forEach(async (compId) => {
			await compsLifeCycle.waitForComponentToRender(compId)
			MotionEffectsManager.prototype.unhideComponent(compId)
		})

	if (reducedMotion && !isSSR(browserWindow)) {
		unhideComponents(Object.keys(animationDefsByCompId))
		return
	}

	return (compId: string, displayedId: string, dom: HTMLElement | null) => {
		if (!dom) {
			return
		}

		if (reducedMotion) {
			motionEffectsManager.unhideComponent(compId)
			return
		}

		if (displayedId !== compId) {
			let compAnimations = animationDefsByCompId[compId]
			const repeaterTemplateData = JSON.parse(JSON.stringify(compAnimations))

			Object.keys(repeaterTemplateData).forEach((effectId: string) =>
				compAnimations[effectId].forEach((effect) => (effect.targetId = displayedId))
			)
			compAnimations = repeaterTemplateData

			motionEffectsManager.addDefinition(compAnimations, dom, rotations[compId])
		}
	}
}

export const MotionEffectsInitCallbackFactory = withDependencies(
	[
		named(PageFeatureConfigSymbol, name),
		named(FeatureStateSymbol, name),
		ReducedMotionSymbol,
		BrowserWindowSymbol,
		CompsLifeCycleSym,
	],
	motionEffectsInitCallbackFactory
)
